import { IDictionary, SurveyTypes } from '../../extViewmodels';
import { useClientGetSurveyByToken } from '../../queries';
import { ISurvey } from './Api';

export function useSurvey<TSurvey extends ISurvey = ISurvey>({
	accessToken,
	options,
	type,
}: {
	accessToken?: string;
	options?: IDictionary<string>;
	type?: SurveyTypes;
}) {
	const hasAccessToken = accessToken && accessToken.toLocaleLowerCase() !== 'unavailable';
	const surveyQuery = useClientGetSurveyByToken<TSurvey>({
		accessToken,
		enabled: hasAccessToken,
		options,
		type,
	});

	const nowDate = new Date();
	const isUnavailable =
		accessToken?.toLocaleLowerCase() === 'unavailable' ||
		surveyQuery.data?.archivedDate ||
		(surveyQuery.data?.startDate ? new Date(surveyQuery.data?.startDate) > nowDate : false) ||
		(surveyQuery.data?.expirationDate ? new Date(surveyQuery.data?.expirationDate) < nowDate : false);

	return { hasAccessToken, isUnavailable, surveyQuery };
}
